<template>
  <div>
    <!-- BEGIN #subscribe -->
    <div id="subscribe" class="section-container bg-silver p-t-30 p-b-30">
      <!-- BEGIN container -->
      <div class="container">
        <!-- BEGIN row -->
        <div class="row">
          <!-- BEGIN col-6 -->
          <div class="col-md-6 col-sm-6">
            <!-- BEGIN subscription -->
            <div class="subscription">
              <div class="subscription-intro">
                <h4 class="">SUBSCRIBE</h4>
                <p>Subscribe to the womia newsletter</p>
              </div>
              <div class="subscription-form">
                <div class="input-group">
                  <input type="text" class="form-control" name="email" v-model="email" placeholder="Enter Email Address" />
                  <div class="input-group-btn">
                    <button class="btn btn-inverse" @click="subscribe()"><i class="fa fa-angle-right"></i></button>
                  </div>
                </div>
                <small :class="message.alert" class="alert text-center p-5 m-0" v-if="message.text" role="alert" style="width: 100%; display: inline-block;">
                  <span class="close" @click="message = {}">×</span>
                  {{ message.text }}
                </small>
              </div>
            </div>
            <!-- END subscription -->
          </div>
          <!-- END col-6 -->
          <!-- BEGIN col-6 -->
          <div class="col-md-6 col-sm-6">
            <!-- BEGIN social -->
            <div class="social">
              <div class="social-intro">
                <h4>FOLLOW US</h4>
                <p>We want to hear from you!</p>
              </div>
              <div class="social-list">
                <a href="#"><i class="fa fa-facebook"></i></a>
                <a href="#"><i class="fa fa-twitter"></i></a>
                <a href="#"><i class="fa fa-linkedin"></i></a>
              </div>
            </div>
            <!-- END social -->
          </div>
          <!-- END col-6 -->
        </div>
        <!-- END row -->
      </div>
      <!-- END container -->
    </div>
    <!-- END #subscribe -->
  </div>
</template>
<script>
export default {
  name: 'FooterSubscribe',
  data() {
    return {
      email: null,
      message: {}
    }
  },
  methods: {
    showMessage(message) {
      this.message = message
    },
    subscribe() {
      this.message = {}
      this.$http
        .post(`subscription/subscribe`, { email: this.email })
        .then(
          response => {
            this.showMessage({ text: 'Thank you for subscribing!', alert: 'alert-success' })
            this.email = null
          },
          err => {
            // error callback
            if (err.body && err.body.message === 'subscription.email.alreadysubscribed') {
              this.showMessage({ text: 'Sorry, this email is already subscribed', alert: 'alert-danger' })
            } else {
              this.showMessage({ text: 'Sorry, your email is not valid', alert: 'alert-danger' })
            }
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FooterSubscribe.vue